import { render, staticRenderFns } from "./TrademarkHistoryList.vue?vue&type=template&id=224509c9&"
import script from "./TrademarkHistoryList.vue?vue&type=script&lang=js&"
export * from "./TrademarkHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkHistoryList.vue?vue&type=style&index=0&id=224509c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports